import { getRangePickerValue } from '@intelligence/v3/filterControls/rangePicker/utils';

import type { IRangePickerFilterValue } from '@intelligence/v3/filterControls/rangePicker/types';

export interface IRobloxReleaseDateFilterParam {
  start_release_date?: string;
  end_release_date?: string;
}

export const buildRobloxReleaseDateFilterParam = (
  releaseTime?: IRangePickerFilterValue,
): IRobloxReleaseDateFilterParam => {
  const { startDate, endDate } = getRangePickerValue(releaseTime);

  if (!startDate || !endDate) {
    return {};
  }

  return {
    start_release_date: startDate,
    end_release_date: endDate,
  };
};
